import useSWR from 'swr'
import useSWRImmutable from 'swr/immutable'

import { getAll, getBycompany, getById, getAllJobOfferApplications, getJobOfferApplicationByOfferId, getJobOfferEngagements, getLatestAcademicTranscript } from '../../../api/job-offers'

// Constants for cache keys
const CACHE_BASE = 'job-offers'
const CACHE_KEYS = {
  ALL_JOB_OFFERS: `${CACHE_BASE}/all`,
  JOB_OFFER_BY_ID: (eventId: number) => `${CACHE_BASE}/${eventId}`,
  COMPANY_JOBS: (companyId: number) => `${CACHE_BASE}/company/${companyId}`,
  APPLICATIONS_BY_JOB_OFFER: (jobOfferId: number) => `${CACHE_BASE}/applications/${jobOfferId}`,
  LATEST_ACADEMIC_TRANSCRIPT: `${CACHE_BASE}/academic-transcript/latest`,
} as const

// Hook for all job offers
export const useJobOffers = (limit?: number) => {
  return useSWR(
    [CACHE_KEYS.ALL_JOB_OFFERS, limit],
    () => getAll({ limit })
  )
}

// Hook for a single job offer
export const useJobOffer = (jobOfferId: number | null) => {
  return useSWRImmutable(
    jobOfferId ? CACHE_KEYS.JOB_OFFER_BY_ID(jobOfferId) : null,
    () => jobOfferId ? getById(jobOfferId) : undefined
  )
}

// Hook for company job offers
export const useCompanyJobOffers = (companyId: number, limit?: number) => {
  return useSWRImmutable(
    companyId ? CACHE_KEYS.COMPANY_JOBS(companyId) : null,
    () => getBycompany({ companyId, limit})
  )
}

export const useAllJobOfferApplications = () => useSWR('/job-offers/my-applications', getAllJobOfferApplications )

export const useJobOfferApplication = (jobOfferId: number | null) => {
  return useSWRImmutable(
    jobOfferId ? CACHE_KEYS.APPLICATIONS_BY_JOB_OFFER(jobOfferId) : null,
    () => jobOfferId ? getJobOfferApplicationByOfferId(jobOfferId) : undefined
  )
}

export const useJobOfferEngagements = () => {
  return useSWR('/job-offers/engaged', getJobOfferEngagements)
}

export const useLatestAcademicTranscript = () => {
  return useSWR(CACHE_KEYS.LATEST_ACADEMIC_TRANSCRIPT, getLatestAcademicTranscript)
}
